export default {
  "show_more_statistics_title": "展示更多统计",
  "show_more_statistics_tips": "统计值将展示在表格末尾。",
}
